import React from 'react';

const CompetencyProfilePage2 = ({ data }) => {
  // Note: Backend stores all data in page_1 (awareness, sensitivity, creativity)
  // Page 2 component just displays sensitivity and creativity from page_1
  const sensitivity = data?.sensitivity || {};
  const creativity = data?.creativity || {};

  const initializeAbility = () => ({
    grade_9: { B: false, P: false, A: false },
    grade_10: { B: false, P: false, A: false },
    grade_11: { B: false, P: false, A: false },
    grade_12: { B: false, P: false, A: false }
  });

  const sensitivityAbilities = [
    { key: 'collaboration_teamwork', label: 'Collaboration and\nteamwork' },
    { key: 'ethical_moral_reasoning', label: 'Ethical and moral\nreasoning' },
    { key: 'human_constitutional_values', label: 'Knowledge and\npractice of human\nand Constitutional\nvalues' },
    { key: 'gender_sensitivity', label: 'Gender sensitivity' },
    { key: 'citizenship_skills', label: 'Citizenship skills\nand values' },
    { key: 'fundamental_duties', label: 'Fundamental duties' }
  ];

  const creativityAbilities = [
    { key: 'scientific_temper', label: 'Scientific temper\nand evidence-based\nthinking' },
    { key: 'creativity_innovativeness', label: 'Creativity and\ninnovativeness' },
    { key: 'sense_aesthetics_art', label: 'Sense of aesthetics\nand art' },
    { key: 'critical_thinking', label: 'Critical thinking' },
    { key: 'problem_solving', label: 'Problem-solving' },
    { key: 'skills_training', label: 'Skills training' },
    { key: 'coding_computational', label: 'Coding and\ncomputational\nthinking' }
  ];

  const grades = [
    { key: 'grade_9', label: 'GRADE - 9', bgColor: '#A8D08D' },
    { key: 'grade_10', label: 'GRADE - 10', bgColor: '#9DC3E6' },
    { key: 'grade_11', label: 'GRADE - 11', bgColor: '#FFD966' },
    { key: 'grade_12', label: 'GRADE - 12', bgColor: '#F4B183' }
  ];

  const renderAbilityRow = (section, ability, index) => {
    const abilityData = section?.[ability.key] || initializeAbility();
    const rowBg = index % 2 === 0 ? '#F2F2F2' : '#FFFFFF';

    return (
      <tr key={ability.key} style={{ backgroundColor: rowBg }}>
        <td style={{
          padding: '10px 12px',
          fontSize: '11px',
          color: 'white',
          backgroundColor: '#4472C4',
          border: '1px solid #2C3E50',
          whiteSpace: 'pre-line',
          lineHeight: '1.3',
          verticalAlign: 'top'
        }}>
          {String.fromCharCode(97 + index)}) {ability.label}
        </td>
        {grades.map(grade => (
          <React.Fragment key={grade.key}>
            {['B', 'P', 'A'].map(level => (
              <td key={level} style={{
                padding: '6px',
                textAlign: 'center',
                backgroundColor: grade.bgColor,
                border: '1px solid #999',
                width: '40px'
              }}>
                {abilityData[grade.key]?.[level] && (
                  <div style={{
                    width: '16px',
                    height: '16px',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#333'
                  }}>
                    ✓
                  </div>
                )}
              </td>
            ))}
          </React.Fragment>
        ))}
      </tr>
    );
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      margin: '0 auto',
      padding: '20mm',
      backgroundColor: 'white',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #FF8C42 transparent transparent'
      }} />

      {/* Section 2: SENSITIVITY */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '2px solid #2C3E50',
        marginBottom: '20px'
      }}>
        <thead>
          <tr>
            <th rowSpan={2} style={{
              padding: '12px',
              textAlign: 'center',
              fontSize: '13px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#1E3A5F',
              border: '1px solid #2C3E50',
              width: '200px'
            }}>
              ABILITIES
            </th>
            <th colSpan={12} style={{
              padding: '10px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#2C4A6F',
              border: '1px solid #2C3E50'
            }}>
              Performance Level Descriptors
            </th>
          </tr>
          <tr>
            {grades.map(grade => (
              <th key={grade.key} colSpan={3} style={{
                padding: '8px',
                textAlign: 'center',
                fontSize: '11px',
                fontWeight: 'bold',
                color: '#333',
                backgroundColor: grade.bgColor,
                border: '1px solid #999'
              }}>
                {grade.label}
              </th>
            ))}
          </tr>
          <tr style={{ backgroundColor: '#E7E6E6' }}>
            <th style={{
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#4472C4',
              border: '1px solid #2C3E50'
            }}>
              2. SENSITIVITY
            </th>
            {grades.map(grade => (
              <React.Fragment key={grade.key}>
                {['B', 'P', 'A'].map(level => (
                  <th key={level} style={{
                    padding: '6px',
                    textAlign: 'center',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#333',
                    backgroundColor: '#E7E6E6',
                    border: '1px solid #999'
                  }}>
                    {level}
                  </th>
                ))}
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {sensitivityAbilities.map((ability, index) => renderAbilityRow(sensitivity, ability, index))}
        </tbody>
      </table>

      {/* Section 3: CREATIVITY */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '2px solid #2C3E50',
        marginBottom: '30px'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#E7E6E6' }}>
            <th style={{
              padding: '8px',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#4472C4',
              border: '1px solid #2C3E50',
              width: '200px'
            }}>
              3. CREATIVITY
            </th>
            {grades.map(grade => (
              <React.Fragment key={grade.key}>
                {['B', 'P', 'A'].map(level => (
                  <th key={level} style={{
                    padding: '6px',
                    textAlign: 'center',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    color: '#333',
                    backgroundColor: '#E7E6E6',
                    border: '1px solid #999'
                  }}>
                    {level}
                  </th>
                ))}
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {creativityAbilities.map((ability, index) => renderAbilityRow(creativity, ability, index))}
        </tbody>
      </table>

      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '12px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        2
      </div>

      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #FF8C42'
      }} />

      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '50px 50px 0 0',
        borderColor: 'transparent #FFB347 transparent transparent',
        opacity: 0.5
      }} />
    </div>
  );
};

export default CompetencyProfilePage2;
